module.exports = __webpack_public_path__ + "img/background.2d31f36c.png";